__turbopack_context__.v({
  "zeroCaseWrapper": "exploreTableZeroCase-module-scss-module__g--Kqq__zeroCaseWrapper",
});
